// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import 'swiper/swiper-bundle.css';

// init Swiper:
const swiper = new Swiper('.swiper', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 1,
	slidesPerView: 'auto',
	effect: "fade",
	autoplay: {
        delay: 3000, //4秒後に次の画像へ
        disableOnInteraction: false //ユーザー操作後に自動再生を再開
	},
	speed: 1500,
	allowTouchMove: false,

	// If we need pagination
	// pagination: {
	//   el: '.swiper-pagination',
	// },

	// Navigation arrows
	// navigation: {
	//   nextEl: '.swiper-button-next',
	//   prevEl: '.swiper-button-prev',
	// },

	// And if we need scrollbar
	scrollbar: {
	  el: '.swiper-scrollbar',
	},
	breakpoints: {
		// 768px以上の場合
		768: {
			// slidesPerView: 'auto',
		},
	}
});
